import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import routeGuard from "../guard/routeGuard";
const  { validationRoute } = routeGuard

Vue.use(VueRouter);
const routes = [
  // LOGIN
  {
    path: "/",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("@/components/modules/login/Login.vue"),
      },
    ],
  },

   // teste paciente qrcode
   {
    path: "/qrcode",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "QRcode",
        component: () => import("@/components/modules/patient_qrcode/qrcode.vue"),
      },
      {
        path: "paciente/:health_center_id/:unity_reference_id/:user_id",
        name: "Paciente QRcode",
        component: () => import("@/components/modules/patient_qrcode/patient.vue"),
      },
    ],
  },

  // Acesso Rápido (antigo dashboard)
  {
    path: "/acesso-rapido",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Acesso Rápido",
        permission: "dashboard",
        component: () => import("@/components/modules/quick-access/Grid.vue"),
      },
    ],
  },

  // CAD. BÁSICOS
  // PERFIS
  {
    path: "/perfis",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Lista de perfis",
        permission: "list_perfil",
        component: () => import("@/components/modules/profiles/Grid.vue"),
      },
    ],
  },

  // USUARIOS
  {
    path: "/usuarios",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Lista de Operador",
        permission: "list_usuario",
        component: () => import("@/components/modules/users/Grid.vue"),
      },
    ],
  },

  // MINHA CONTA
  {
    path: "/minha-conta",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Minha Conta",
        permission: "account",
        component: () => import("@/components/modules/my-account/Account.vue"),
      },
    ],
  },

  // RESETAR SENHA
  {
    path: "/esqueci-minha-senha",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "Esqueci minha senha",
        component: () => import("@/components/modules/password/Password.vue"),
      },
    ],
  },
  {
    path: "/municipios",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Municípios",
        component: () => import("@/components/modules/county/Grid.vue"),
      },
    ],
  },
  {
    path: "/unidades",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Unidades",
        component: () => import("@/components/modules/unit/Grid.vue"),
      },
      {
        path: "adicionar",
        name: "Adicionar Unidade",
        component: () => import("@/components/modules/unit/Unit.vue"),
      },
    ],
  },
  {
    path: "/origens",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        permission: "list_origem",
        name: "Consultar Circuito",
        component: () => import("@/components/modules/origin/Grid.vue"),
      },
    ],
  },
  {
    path: "/postos",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Postos",
        permission: "list_posto_saude",
        component: () => import("@/components/modules/post/Grid.vue"),
      },
    ],
  },
  {
    path: "/evento",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Parametrização do evento",
        permission: "list_evento",
        component: () =>
          import("@/components/modules/parameterization/Grid.vue"),
      },
      {
        path: "adicionar",
        name: "Adicionar Parametrização do evento",
        permission: "list_evento",
        component: () =>
          import("@/components/modules/parameterization/Post.vue"),
      },
      {
        path: "editar/:id",
        name: "Editar Parametrização do evento",
        permission: "list_evento",
        component: () =>
          import("@/components/modules/parameterization/Post.vue"),
      },
    ],
  },
  {
    path: "/causa",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Causa",
        permission: "list_causa",
        component: () => import("@/components/modules/cause/Grid.vue"),
      },
    ],
  },
  {
    path: "/diagnostico",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Diagnóstico",
        permission: "list_diagnostico",
        component: () => import("@/components/modules/diagnosis/Grid.vue"),
      },
    ],
  },
  {
    path: "/resolutividade",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name:
          // userData.module_id === 1
            "Consultar Resolutividade/Desfecho",
            // : "Consultar Resolutividade",
        permission: "list_resolutividade",
        component: () => import("@/components/modules/resoluteness/Grid.vue"),
      },
    ],
  },
  {
    path: "/procedimento",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name:
          // userData.module_id === 1
            "Consultar Tipo de Atendimento/Procedimento",
            // : "Consultar Procedimento",
        permission: "list_procedimento",
        component: () => import("@/components/modules/procedures/Grid.vue"),
      },
    ],
  },
  {
    path: "/medico",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Médico",
        permission: "list_profissional",
        component: () => import("@/components/modules/doctor/Grid.vue"),
      },
      {
        path: "escala/:id",
        name: "Consultar Escala Médica",
        permission: "cad_escala",
        component: () => import("@/components/modules/doctor/ScreemMedicalScale.vue"),
      },
      {
        path: "gerar-escala",
        name: "Gerar Escala Médica",
        permission: "cad_escala",
        component: () => import("@/components/modules/doctor_scale/Form.vue"),
      },
    ],
  },
  {
    path: "/procedencia",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Procedência",
        permission: "list_procedimento",
        component: () => import("@/components/modules/provenance/Grid.vue"),
      },
    ],
  },
  {
    path: "/ocorrencia",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Ocorrência",
        permission: "list_ocorrencia",
        component: () => import("@/components/modules/ocorrencias/vigilance/Grid.vue"),
      },
      {
        path: "editar/:id",
        name: "Editar Ocorrência",
        permission: "cad_ocorrencia",
        component: () => import("@/components/modules/ocorrencias/vigilance/Actions/PatientOccurrence.vue"),
      },
      {
        path: "criar",
        name: "Cadastrar Usuário",
        permission: "cad_paciente",
        component: () => import("@/components/modules/ocorrencias/vigilance/Actions/PatientOccurrence.vue"),
      },
     
      {
        path: "aconselhamento",
        name: "Criar Ocorrencia",
        permission: "cad_aconselhamento",
        component: () =>
          import("@/components/modules/ocorrencias/vigilance/Actions/CounselorScreen.vue"),
      },
      
      {
        path: "medicas",
        name: "Consultar Ocorrências Médicas",
        permission: "list_ocorrencia",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/DoctorGrid.vue"),
      },
      {
        path: "medicas/incluir",
        name: "Cadastrar Paciente",
        permission: "cad_ocorrencia",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/Actions/PatientOccurrence.vue"),
      },
      {
        path: "medicas/editar/:id",
        name: "Editar Paciente",
        permission: "cad_ocorrencia",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/Actions/PatientOccurrence.vue"),
      },
      {
        path: "medicas/incluir/ocorrencia",
        name: "Adicionar Ocorrências Médicas",
        permission: "cad_ocorrencia",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/Actions/Occurrence.vue"),
      },
      {
        path: "medicas/editar/ocorrencia/:id",
        name: "Editar Ocorrências Médicas",
        permission: "cad_ocorrencia",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/Actions/Occurrence.vue"),
      },
      {
        path: "/ocorrencia/medicas/detalhes/:id",
        name: "Detalhes Ocorrências Médicas",
        permission: "list_ocorrencia",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/Actions/Details.vue"),
      },
      {
        path: "/ocorrencia/medicas/triagem",
        name: "Cadastro de triagem",
        permission: "create_medical_triage",
        component: () =>
          import("@/components/modules/ocorrencias/doctor/Actions/PatientScreening.vue"),
      },
      {
        path: "vacinas",
        name: "Consultar Vacinação",
        permission: "list_ocourrence_vaccine",
        component: () =>
          import("@/components/modules/ocorrencias/vaccine/Grid.vue"),
      },
      {
        path: "vacina/criar",
        name: "Cadastrar Paciente",
        permission: "create_ocourrence_vaccine",
        component: () =>
          import("@/components/modules/ocorrencias/vaccine/Actions/PatientVaccine.vue"),
      },
      {
        path: "vacina/editar/:id",
        name: "Editar Paciente",
        permission: "create_ocourrence_vaccine",
        component: () =>
          import("@/components/modules/ocorrencias/vaccine/Actions/PatientVaccine.vue"),
      },
      {
        path: "vacina/triagem/:id",
        name: "Cadastrar Triagem",
        permission: "list_ocourrence_vaccine",
        component: () =>
          import("@/components/modules/ocorrencias/vaccine/Actions/ScreeningVaccine.vue"),
      },
      {
        path: "vacina/lancamento/:id",
        name: "Cadastrar Lançamento",
        permission: "list_ocourrence_vaccine",
        component: () =>
          import("@/components/modules/ocorrencias/vaccine/Actions/LaunchVaccine.vue"),
      },
    ],
  },
  {
    path: "/agendaSAE",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Agenda SAE",
        permission: "list_agenda", 
        component: () => import("@/components/modules/schedule/Grid.vue"),
      },
    ],
  },
  {
    path: "/testes",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Testes",
        permission: "list_teste",
        component: () => import("@/components/modules/test/Grid.vue"),
      },
    ],
  },
  
  {
    path: "/log",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name:
            "Consultar LOG",
        permission: "list_logs",
        component: () => import("@/components/modules/log/Grid.vue"),
      },
    ],
  },
   {
    path: "/vacinas",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name:
            "Consultar Vacinas",
        permission: "list_vaccine",
        component: () => import("@/components/modules/vaccines/Grid.vue"),
      },
    ],
  },

  {
    path: "/contagem-vacinacao",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name:
            "Contagem Vacinação",
        permission: "list_vaccine",
        component: () => import("@/components/modules/vaccine_count/Grid.vue"),
      },
      {
        path: "quantidade/:id",
        name:
            "Quantidade Vacinação",
        permission: "list_vaccine",
        component: () => import("@/components/modules/vaccine_count/Count.vue"),
      },
    ],
  },
   {
    path: "/relatorio",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "medicas",
        name:
            "Relatório de Ocorrências Médicas",
        permission: "report_medical_occurrences",
        component: () => import("@/components/modules/report/OcurrenceDoctor.vue"),
      },
      {
        path: "testagem",
        name:
            "Relatório de Ocorrências Testagem",
        permission: "report_testing_occurrences",
        component: () => import("@/components/modules/report/OcurrenceTesting.vue"),
      },
       {
        path: "vacinacao",
        name:
            "Relatório de Ocorrências Vacinação",
        permission: "report_vaccine_occurrences",
        component: () => import("@/components/modules/report/OcurrenceVacine.vue"),
      },
    ],
  },
  
];

store.state.localRoutes = routes;

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});
export default router;
